import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import getContrastFontColor from '@utils/getContrastFontColor';
import { DiscountPrice } from '../Price';

export const Title = styled.h2`
  font-size: 24px;
  padding: 10px 0;
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.headerFont};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  color: ${({ theme }) => theme.sectionTitleColour};
  word-break: break-word;
  word-wrap: break-word;

  ${media.xl`
    font-size: 35px;
    margin-top: 0;
    margin-bottom: 100px;
  `}
`;

export const Duration = styled.div`
  display: none;

  ${media.lg`
    margin-top: 1rem;
    display: block;
  `}
`;

export const DurationMobile = styled.div`
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  display: flex;
  flex-direction: column;
  margin-right: 100px;
  ${media.lg`
    display: none;
  `}
  p {
    color: ${({ theme }) => theme.defaultColors.fontSecondary};
    margin-bottom: ${({ theme }) => theme.spaces.space1};
  }
`;
export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${({ theme }) => theme.spaces.space4};
`;

export const HeaderWrapper = styled.div`
  max-width: 1480px;
  width: 100%;
  margin: 0 auto;
`;

export const InnerWrap = styled.div`
  ${media.xl`
    display: flex;
    flex-direction: row-reverse;
    margin-top: 10px;
  `}
`;

export const Imagewrapper = styled.div`
  ${media.md`
    height: 320px;
  `}

  ${media.lg`
    padding: 0 20px;
  `}

  ${media.xl`
    height: auto;
    flex-grow: 1;
    padding: 0;
  `};
`;

export const HeaderTexts = styled.div`
  --xl-padding: 32px;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};

  ${media.lg`
    padding: 0 20px;
  `}

  ${media.xl`
    flex-shrink: 0;
    min-height: 466px;
    width: 466px;
    background: ${({ theme }: { theme: any }) => theme.customColors.tertiary};
    color: ${({ theme }: { theme: any }) =>
      getContrastFontColor(
        theme.customColors.tertiary,
        theme.defaultColors.fontSecondary,
        theme.defaultColors.lightGrey,
        false
      )};
    margin-right: 10px;
    padding: var(--xl-padding);
  `}
`;

export const PriceInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const PriceLabel = styled.p`
  margin-bottom: ${({ theme }) => theme.spaces.space1};
`;

export const HurryMessageWrapper = styled.div`
  ${media.xl`
    position: absolute;
    top: var(--xl-padding);
    right: var(--xl-padding);
  `}
`;

export const StyledPrice = styled(DiscountPrice)`
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  ${media.xl`
    color: ${({ theme }: { theme: any }) =>
      getContrastFontColor(
        theme.customColors.tertiary,
        theme.defaultColors.fontPrimary,
        theme.defaultColors.lighterGrey,
        false
      )};
  `}
`;
